export interface InviteLinks {
  /** https://t.me/<bot> — what a friend opens. */
  bot: string;
  /** Telegram's own «share to a chat» window with the bot link and a short text. */
  share: string;
}

/** The links of «Пригласить»; none when the build has no bot username (the screen explains only). */
export function inviteLinks(botUsername: string | null | undefined, text: string): InviteLinks | null {
  const name = (botUsername ?? '').trim().replace(/^@/, '');
  if (!name) return null;
  const bot = `https://t.me/${name}`;
  return {
    bot,
    share: `https://t.me/share/url?url=${encodeURIComponent(bot)}&text=${encodeURIComponent(text)}`,
  };
}
